var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_916_48053)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 37.0898,
    r: 32,
    fill: "url(#paint0_linear_916_48053)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_916_48053)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42 29.0898C42.855 29.0898 43.732 29.1118 44.582 29.1478L45.586 29.1958L46.547 29.2528L47.447 29.3138L48.269 29.3778C49.161 29.4461 50.0004 29.8268 50.6395 30.4529C51.2786 31.079 51.6764 31.9104 51.763 32.8008L51.803 33.2258L51.878 34.1358C51.948 35.0788 52 36.1068 52 37.0898C52 38.0728 51.948 39.1008 51.878 40.0438L51.803 40.9538C51.79 41.0998 51.777 41.2408 51.763 41.3788C51.6764 42.2695 51.2784 43.101 50.6391 43.7271C49.9999 44.3532 49.1602 44.7338 48.268 44.8018L47.448 44.8648L46.548 44.9268L45.586 44.9838L44.582 45.0318C43.7218 45.0692 42.861 45.0886 42 45.0898C41.139 45.0886 40.2782 45.0692 39.418 45.0318L38.414 44.9838L37.453 44.9268L36.553 44.8648L35.731 44.8018C34.839 44.7336 33.9996 44.3529 33.3605 43.7268C32.7214 43.1007 32.3236 42.2693 32.237 41.3788L32.197 40.9538L32.122 40.0438C32.0455 39.061 32.0048 38.0757 32 37.0898C32 36.1068 32.052 35.0788 32.122 34.1358L32.197 33.2258C32.21 33.0798 32.223 32.9388 32.237 32.8008C32.3235 31.9105 32.7212 31.0793 33.3601 30.4532C33.999 29.8271 34.8381 29.4463 35.73 29.3778L36.551 29.3138L37.451 29.2528L38.413 29.1958L39.417 29.1478C40.2775 29.1105 41.1387 29.0911 42 29.0898ZM40 34.6648V39.5148C40 39.9768 40.5 40.2648 40.9 40.0348L45.1 37.6098C45.1914 37.5572 45.2673 37.4815 45.3201 37.3902C45.3729 37.2989 45.4007 37.1953 45.4007 37.0898C45.4007 36.9844 45.3729 36.8808 45.3201 36.7895C45.2673 36.6982 45.1914 36.6225 45.1 36.5698L40.9 34.1458C40.8088 34.0932 40.7053 34.0654 40.5999 34.0655C40.4945 34.0655 40.3911 34.0932 40.2998 34.1459C40.2086 34.1986 40.1329 34.2744 40.0802 34.3657C40.0276 34.457 39.9999 34.5605 40 34.6658V34.6648Z",
    fill: "#9E120E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_916_48053",
    x: 0,
    y: 0.0898438,
    width: 80,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_916_48053"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.308333 0 0 0 0 0.285208 0 0 0 0 0.285208 0 0 0 0.31 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_916_48053"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_916_48053",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_916_48053",
    x1: 10,
    y1: 37.0898,
    x2: 74,
    y2: 37.0898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E8E8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_916_48053"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(30 25.0898)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.481fa538808adb1223076dbad4c35f6b.svg";
export { ForwardRef as ReactComponent };